import React from 'react';
import PropTypes from 'prop-types';

import { Text, View, StyleSheet } from '@react-pdf/renderer';

import PdfStyles from './PdfStyles';

const PdfFooter = ({ footerSupport, page }) => {
  const styles = StyleSheet.create(PdfStyles);

  return (
    <View style={styles.footer} fixed={true}>
      <View style={styles.subFooter}>
        <Text>{footerSupport}</Text>
      </View>
      <Text
          style={styles.pageNumber}
          render={({ pageNumber }) =>
            `${page} ${pageNumber}`
          }
          fixed={true}
        />
    </View>
  );
};

PdfFooter.propTypes = {
  footerSupport: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
};

export default PdfFooter;
